import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at top, #FBF4EC 0%, #F5EDE4 60%, #EFE5D9 100%)'
  }} data-id="element-188">
      <div className="absolute top-10 left-1/4 w-[380px] h-[380px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(196, 181, 253, 0.35)'
    }} data-id="element-189"></div>
      <div className="absolute bottom-10 right-1/4 w-[340px] h-[340px] rounded-full blur-[90px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(252, 211, 211, 0.35)'
    }} data-id="element-190"></div>

      <div className="relative bg-white border border-[#E8D5C4] text-[#9D4D4D] font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-sm" data-id="element-191">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-[#D97570] animate-pulse" data-id="element-192"></span>
        <span className="hidden sm:inline" data-id="element-193">
          🧘‍♀️ ACHTUNG YOGA-LEHRER: SCHLUSS MIT UNENDLICHEN ABENDEN BEI DER
          STUNDENPLANUNG
        </span>
        <span className="sm:hidden" data-id="element-194">ACHTUNG: YOGA-LEHRER</span>
      </div>

      <h1 className="relative font-black max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight" style={{
      color: '#2A2438'
    }} data-id="element-195">
        Erledigen Sie ein ganzes Jahr Yoga-Unterricht in{' '}
        <span className="text-transparent bg-clip-text" style={{
        backgroundImage: 'linear-gradient(90deg, #8B6FBF 0%, #D98AA8 100%)'
      }} data-id="element-196">
          nur 5 Minuten.
        </span>
      </h1>

      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/60 sm:backdrop-blur-sm sm:border sm:border-[#E8D5C4] sm:border-l-4 sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left sm:shadow-sm" style={{
      color: '#5C5470',
      borderLeftColor: '#8B6FBF'
    }} data-id="element-197">
        Das{' '}
        <span className="font-bold" style={{
        color: '#8B6FBF'
      }} data-id="element-198">
          „Aufschlagen & Unterrichten“-Kit
        </span>{' '}
        mit fertigen Sequenzen, philosophischen Themen und Varianten für jedes
        Level.{' '}
        <span className="hidden sm:inline font-semibold" style={{
        color: '#2A2438'
      }} data-id="element-199">
          Holen Sie sich Ihre Wochenenden zurück.
        </span>
      </p>

      <div className="relative w-full max-w-[280px] sm:max-w-[440px] md:max-w-[540px] mx-auto mb-4 sm:mb-8" data-id="element-200">
        <div className="absolute inset-0 blur-[50px] rounded-full hidden sm:block" style={{
        background: 'rgba(196, 181, 253, 0.25)'
      }} data-id="element-201"></div>
        <img src="https://cdn.magicpatterns.com/uploads/7vW1oFHJibo638uxmodUJq/Diseno-sin-titulo-_46__(1).webp" alt="YOGA-BEREIT: DAS ULTIMATIVE KOMPLETT-SYSTEM — Integrales Lehr-System" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(90,70,120,0.25)]" width={500} height={500} fetchPriority="high" loading="eager" decoding="async" data-id="element-202" />
      </div>

      <div className="relative flex flex-col items-center gap-2 mb-4 sm:mb-6" data-id="element-203">
        <div className="flex items-center gap-2" data-id="element-204">
          <span className="text-sm sm:text-lg" style={{
          color: '#E0A52E'
        }} data-id="element-205">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-xs sm:text-base font-medium" style={{
          color: '#5C5470'
        }} data-id="element-206">
            4.9/5 (+800 verifizierte Bewertungen)
          </span>
        </div>
        <span className="font-bold text-xs sm:text-sm px-3 py-1 rounded-full border" style={{
        color: '#A0651D',
        backgroundColor: '#FDF4E3',
        borderColor: '#E8D5C4'
      }} data-id="element-207">
          🔥 62 Lehrer in Deutschland haben dieses Kit heute bereits gewählt
        </span>
      </div>

      <a href="#pricing" onClick={() => {
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'AddToCart', {
          content_name: 'Yoga-Bereit — Das Komplett-Kit',
          content_type: 'product',
          value: 27,
          currency: 'EUR'
        });
      }
    }} className="relative btn-primary-pulse font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white" style={{
      backgroundColor: '#0F8B6F'
    }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0B6E58'} onMouseLeave={e => e.currentTarget.style.backgroundColor = '#0F8B6F'} data-id="element-208">
        🚀 JA! ICH WILL MEINE ZEIT ZURÜCKGEWINNEN
      </a>

      <p className="relative text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" style={{
      color: '#5C5470'
    }} data-id="element-209">
        <span data-id="element-210">⚡ Sofortiger Zugriff</span>
        <span data-id="element-211">•</span>
        <span data-id="element-212">🛡️ 30 Tage Garantie</span>
        <span data-id="element-213">•</span>
        <span data-id="element-214">💳 Einmalzahlung</span>
      </p>
    </section>;
}